export function setRealProperties(brick, realProps) {
  if (!realProps) {
    return;
  }
  for (const [propName, propValue] of Object.entries(realProps)) {
    switch (propName) {
      case "style":
      case "dataset":
        for (const [k, v] of Object.entries(propValue)) {
          if (propName === "style") {
            setValueForStyle(brick.style, k, v);
          } else {
            brick[propName][k] = v;
          }
        }
        break;
      case "constructor":
      case "__proto__":
      case "innerHTML":
        // `innerHTML` is dangerous, use `textContent` instead.
        throw new Error(`set \`${propName}\` is prohibited`);
      default:
        if (propName.startsWith("data-")) {
          brick.setAttribute(propName, String(propValue));
        } else {
          brick[propName] = propValue;
        }
    }
  }
}
export function setValueForStyle(style, key, value) {
  if (key.startsWith("--")) {
    style.setProperty(key, value);
  } else if (key === "float") {
    style.cssFloat = value;
  } else {
    style[key] = value;
  }
}
//# sourceMappingURL=setRealProperties.js.map